module.exports = __webpack_public_path__ + "img/tuiguang2-1-4.33f4e8d4.png";